import { TColumn } from './column.model';
import { GET_GROUPING } from './grouping.store';
import { GET_SORTING } from './sorting.store';

export function getAllGroupedSortedColumns(): TColumn[] {
  const sorting = GET_SORTING().sort((a, b) => a.sortIndex - b.sortIndex);
  const grouping = GET_GROUPING()
    .sort((a, b) => a.groupIndex - b.groupIndex)
    .map((column) => ({
      ...column,
      sortOrder: column.groupOrder,
    }));

  return [...grouping, ...sorting];
}
